export const AVAILABLE_MODELS = [
  { value: 'o3', label: 'GPT o3' },
  { value: 'gpt-4o', label: 'GPT 4o' },
  { value: 'gpt-5-mini', label: 'GPT 5 mini' },
  { value: 'gpt-5-nano', label: 'GPT 5 nano' },
  { value: 'gpt-5', label: 'GPT-5' }
  // { value: 'openai/gpt-oss-20b', label: 'gpt-oss-20b' }

] as const;

export const BEDROCK_MODELS = [
  { value: 'us.anthropic.claude-3-7-sonnet-20250219-v1:0', label: 'Claude Sonnet 3.7' },
  { value: 'us.anthropic.claude-sonnet-4-20250514-v1:0', label: 'Claude Sonnet 4.0' },
  { value: 'us.anthropic.claude-opus-4-20250514-v1:0', label: 'Claude Opus 4.0' }, 
  { value: 'us.meta.llama3-2-3b-instruct-v1:0', label: 'Llama 3.2 3b Instruct' }, 
  { value: 'us.meta.llama3-2-11b-instruct-v1:0', label: 'Llama 3.2 11b Instruct' },   
  { value: 'us.meta.llama3-2-90b-instruct-v1:0', label: 'Llama 3.2 90b Instruct' }, 
] as const;

export type AvailableModel = typeof AVAILABLE_MODELS[number]['value'];
export type BedrockModel = typeof BEDROCK_MODELS[number]['value'];

export const DEFAULT_MODEL: AvailableModel = 'gpt-4o';
export const DEFAULT_BEDROCK_MODEL: BedrockModel = 'us.anthropic.claude-3-7-sonnet-20250219-v1:0';

export const DEFAULT_BASE_PROMPT = 'You are a helpful assistant. Format your responses in markdown when appropriate to make them more readable. Use headings, lists, bold, italic, and code blocks where appropriate.';

export const DEFAULT_PROJECT = {
  name: 'New Project',
  base_prompt: DEFAULT_BASE_PROMPT,
  model_name: DEFAULT_MODEL,
  chat_type: 'direct',
  rag_top_k: 3,
  rag_confidence_threshold: 0.7,
  rag_token_limit: 4000
};

export const getFormattedTimestamp = () => new Date().toLocaleTimeString([], { 
  hour: '2-digit', 
  minute: '2-digit',
  hour12: false 
});
